import superMeta from '../_CAT_ROOT_MODULE/metaCatRootModuleNode.mjs'

export default {
    ...superMeta,
    moduleIdProp: 'amId',
    moduleType: 'AM',
    name: '分析模块',
    type: 'CAT_ROOT_AM',
}
